module.exports = __webpack_public_path__ + "share-13c77cee85ff8f65d0ab01721f66ad32.svg";